import { types } from 'mobx-state-tree';
import {
	BaseCommunicator,
	ICSV2,
	ICSCustomersAPI,
} from '@icecreamsocial/communicators';

const Communicators = types
	.compose(
		BaseCommunicator,
		types.model({
			V1: ICSCustomersAPI,
			Client: ICSV2.ICSClientAPIV2,
			Public: ICSV2.ICSPublicAPIV2,
		})
	)
	.named('Communicators');

export default types.snapshotProcessor(Communicators, {
	preProcessor(snap = {}) {
		return {
			...snap,
			V1: snap.V1 || {},
			Client: snap.Client || {},
			Public: snap.Public || {},
		};
	},
});
